/* ============================================================
 * EcoSmiles · UTM capture + GHL bridge
 * ------------------------------------------------------------
 * Captura UTMs del URL, guarda en cookies (first + last touch),
 * dispatcha al dataLayer (GA4 los lee), y los expone como hidden
 * fields para cualquier form que se envie a GHL.
 *
 * Convencion canonica: ver prompts/ghl_utm_convention_v1.md
 * ============================================================ */
(function() {
  if (window.__ecoUTMCapture) return;
  window.__ecoUTMCapture = true;
  window.dataLayer = window.dataLayer || [];

  var UTM_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  var COOKIE_FIRST = 'ecosmiles_first_touch';
  var COOKIE_LAST  = 'ecosmiles_last_touch';
  var FIRST_TTL = 60 * 60 * 24 * 365;   // 1 ano
  var LAST_TTL  = 60 * 60 * 24 * 30;    // 30 dias

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function setCookie(name, value, ttl) {
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; max-age=' + ttl + '; path=/; samesite=lax' +
      (location.protocol === 'https:' ? '; secure' : '');
  }
  function parseUTMs() {
    var params = new URLSearchParams(window.location.search);
    var out = {};
    var any = false;
    UTM_KEYS.forEach(function(k) {
      var v = params.get(k);
      if (v) { out[k] = v; any = true; }
    });
    if (!any) return null;
    out.referrer = document.referrer || '';
    out.landing_page = window.location.pathname;
    out.captured_at = new Date().toISOString();
    return out;
  }
  function safeJSON(s) {
    try { return JSON.parse(s); } catch(e) { return null; }
  }

  // 1) Capturar UTMs del URL si existen
  var currentUTMs = parseUTMs();
  if (currentUTMs) {
    var json = JSON.stringify(currentUTMs);
    // first-touch: solo si no existe
    if (!getCookie(COOKIE_FIRST)) {
      setCookie(COOKIE_FIRST, json, FIRST_TTL);
    }
    // last-touch: siempre actualizar
    setCookie(COOKIE_LAST, json, LAST_TTL);
  }

  // 2) Push al dataLayer (GA4 los capta del URL solo, esto es para tags custom)
  var first = safeJSON(getCookie(COOKIE_FIRST)) || {};
  var last  = safeJSON(getCookie(COOKIE_LAST))  || currentUTMs || {};
  window.dataLayer.push({
    event: 'utm_attribution',
    attribution: {
      first_touch: first,
      last_touch: last,
      current: currentUTMs || null
    }
  });

  // 3) Expose helper global para que cualquier form pueda hidratar hidden inputs
  window.ecosmiles_utm = function() {
    return {
      first_touch: safeJSON(getCookie(COOKIE_FIRST)) || {},
      last_touch: safeJSON(getCookie(COOKIE_LAST)) || {}
    };
  };

  // 4) Auto-hidratar forms de GHL/LeadConnector que tengan <input data-utm=*>
  function hydrateForms() {
    var inputs = document.querySelectorAll('input[data-utm]');
    var data = window.ecosmiles_utm();
    inputs.forEach(function(input) {
      var key = input.getAttribute('data-utm'); // ej. 'last.utm_source'
      var parts = key.split('.');
      var touch = parts[0] === 'first' ? data.first_touch : data.last_touch;
      var utm = parts[1];
      if (touch && touch[utm]) input.value = touch[utm];
    });
  }
  // Hidratar al cargar + cuando aparezcan forms nuevos (popups, etc.)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateForms);
  } else {
    hydrateForms();
  }
  // Observer para forms dinamicos
  var mo = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        hydrateForms();
        break;
      }
    }
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
